import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=95340718&scoped=true&lang=pug&"
import script from "./CustomerTable.vue?vue&type=script&lang=js&"
export * from "./CustomerTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTable.vue?vue&type=style&index=0&id=95340718&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95340718",
  null
  
)

export default component.exports